/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const AngleRightLightIcon = ({
  className,
  style: propStyles,
  color = '#3A50F3',
  onClick,
  size,
}: IconTypeProps) => {
  const style = {
    width: `${size}px`,
    height: `${size}px`,
    ...propStyles,
  };

  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M12.2092 8.39836L6.36947 13.8348C6.13648 14.0551 5.75972 14.0551 5.52672 13.8348L5.17475 13.502C4.94175 13.2818 4.94175 12.9256 5.17475 12.7053L10.2461 8L5.1797 3.29467C4.94671 3.0744 4.94671 2.71822 5.1797 2.49795L5.53168 2.1652C5.76467 1.94493 6.14143 1.94493 6.37443 2.1652L12.2142 7.60164C12.4422 7.82191 12.4422 8.17809 12.2092 8.39836Z"
        fill={color}
      />
    </svg>
  );
};
